import * as PIXI from "pixi.js";
import Point from "./classes/Point";
import { drawTrail } from "./draw-trail";
import { drawSnow } from "./draw-snow";
import { createSnow } from "./create-snow";
import { drawZach } from "./draw-zach";
import { createArmatureFromSkeleton, setupZach } from "./zach-skeleton";

window.addEventListener("load", () => setTimeout(startApp, 1000));

function startApp() {
  PIXI.Loader.shared
    .add("skeleton", "bruhnkeCoin_ske.json")
    .add("texture_atlas", "bruhnkeCoin_tex.json")
    .add("texture_png", "bruhnkeCoin_tex.png")
    .load(onLoadSkeleton);

  const app = new PIXI.Application({
    antialias: true,
    resizeTo: window,
    width: window.innerWidth,
    height: window.innerHeight,
    backgroundColor: 0x006982,
    // resolution: devicePixelRatio,
  });

  document.body.appendChild(app.view);

  app.stage.interactive = true;

  const graphics = new PIXI.Graphics();
  const snowFarGraphics = new PIXI.Graphics();
  const snowNearGraphics = new PIXI.Graphics();
  const center = new Point(window.innerWidth / 2, window.innerHeight / 2);

  const blurFilter1 = new PIXI.filters.BlurFilter(2);
  snowFarGraphics.filters = [blurFilter1];

  const blurFilter2 = new PIXI.filters.BlurFilter(10);
  snowNearGraphics.filters = [blurFilter2];

  let zach;
  function onLoadSkeleton(loader, resources) {
    const armatureDisplay = createArmatureFromSkeleton(resources);
    zach = setupZach(armatureDisplay, app);
    app.stage.addChild(snowNearGraphics);
  }

  let snowFar = createSnow(300, 1, 8);
  let snowNear = createSnow(50, 10, 15);

  app.stage.addChild(graphics);
  app.stage.addChild(snowFarGraphics);

  const trailPoint = center.clone();
  const pointer = new Point(app.screen.width * 0.25, center.y);
  app.renderer.plugins.interaction.on("pointermove", (e) => {
    pointer.moveTo(e.data.global.x, e.data.global.y);
  });

  let isPointerDown = false;
  app.renderer.plugins.interaction.on("pointerdown", (e) => {
    isPointerDown = true;
  });
  app.renderer.plugins.interaction.on("pointerup", (e) => {
    isPointerDown = false;
  });

  let count = 0;

  window.addEventListener("resize", () => {
    center.moveTo(window.innerWidth / 2, window.innerHeight / 2);
    zach.x = center.x;
    zach.y = center.y;
    snowFar = createSnow(300, 1, 8);
    snowNear = createSnow(50, 10, 15);
  });

  app.ticker.add(() => {
    count += 0.1;

    trailPoint.lerp(pointer, 0.05);
    const dist = center.distance(pointer);
    const rad = center.angleRadians(trailPoint);
    const velocity = dist * 0.1;

    graphics.clear();
    snowFarGraphics.clear();
    snowNearGraphics.clear();
    drawTrail(graphics, { dist, rad, velocity, count, center, isPointerDown });
    drawSnow(snowFarGraphics, snowFar, {
      rad,
      velocity,
      count,
      screen: app.screen,
      isPointerDown,
    });
    drawSnow(snowNearGraphics, snowNear, {
      rad,
      velocity,
      count,
      screen: app.screen,
      isPointerDown,
    });
    drawZach(zach, { screen: app.screen, dist, rad, pointer });
  });

  setTimeout(() => {
    app.view.classList.add("has-loaded");
  });
}
